module.exports = __webpack_public_path__ + "img/card_example.57e83cbd.png";